import debounce = require("lodash.debounce");
import { Action, any, async, fromJSX, loadingAsyncState, nothing } from "widgets-for-react";
import { previousOrDefault } from "../../../../custom_api/api_utils";
import { bookSearch } from "../../../../custom_api/collection/api";
import { SearchOn } from "../../../../custom_api/collection/types";
import { WiseBook } from "../../../../custom_api/wise/types";
import { pushBookBasedInspirationAction } from "../../datalayer";
import { history } from "../../history";
import { CollectionPageLoaderWidget } from "../Shared/InspirationUtils";
import { BookBasedInspirationKioskLayout } from "./BookBasedInspirationLayoutKiosk";
import { BookBasedInspirationLayoutWeb } from "./BookBasedInspirationLayoutWeb";
import { BookBasedInspirationLayoutProps, BookBasedInspirationState } from "./BookBasedInspirationState";

type Updater = (_: Action<BookBasedInspirationState>) => void

export const BookBasedInspirationWidget = (props: BookBasedInspirationState) => {
  return any<Action<BookBasedInspirationState>>({ key: 'Book-based' })([
    fromJSX((setState) => {
      const layoutProps: BookBasedInspirationLayoutProps = {
        ...props,
        updateSearchQuery: (searchQuery: string) => {
          updateSearchQuery(setState, searchQuery)
          debouncedSearchResults(setState, searchQuery)
          debouncedSearchQueryAction(searchQuery)
        },
        pickBook: (book) => {
          pushBookBasedInspirationAction("Zoek resultaat uit", book.label)
          history.push(`/${props.routePath}/boek/${book.value.isbn}`);
        }
      }
      return props.isKioskMode
        ? BookBasedInspirationKioskLayout(layoutProps)
        : BookBasedInspirationLayoutWeb(layoutProps)
    }),

    // Handle loading of suggested books
    async<WiseBook[]>(nothing, { key: 'bookBasedPromptsLoader' })(props.prompts)
      .map(resultUpdater => s0 => {
        const prompts = resultUpdater(s0.prompts)
        return ({ ...s0, prompts })
      }),
    
    // Handle loading of searched books
    async<SearchOn[]>(nothing, { key: 'resultLoader'})(props.searchResults).map(updater => s0 => ({...s0, searchResults: updater(s0.searchResults)})),
    CollectionPageLoaderWidget(props)
  ]).map(a => a(props))
}

const updateSearchQuery = (set: Updater, searchQuery: string) => { set((prev) => ({...prev, searchQuery})) }

const loadSearchResults = (set: Updater, searchQuery: string) => { set((prev) =>({
  ...prev,
  searchResults: loadingAsyncState(bookSearch(searchQuery.trim()), previousOrDefault(prev.searchResults, []))
}))}
const debouncedSearchResults = debounce((update: Updater, searchQuery: string) => loadSearchResults(update, searchQuery), 200)

const pushSearchQueryAction = (searchQuery: string) => pushBookBasedInspirationAction("Zoeken", searchQuery)
const debouncedSearchQueryAction = debounce((s: string) => pushSearchQueryAction(s), 1500)
